export const isVertical = orient => "left" === orient || "right" === orient;

export const isHorizontal = orient => "top" === orient || "bottom" === orient;
//# sourceMappingURL=orient.js.map
